<template>
    <div class="card auth-form-card flex flex-col justify-center w-full max-w-[36rem]">
        <header v-if="$slots.header"  class="justify-center justify-items-center gap-4">
            <slot name="header"></slot>
        </header>
        <main class="w-full mb-6"><slot></slot></main>
        <footer v-if="$slots.footer"><slot name="footer"></slot></footer>
    </div>
</template>

<style scoped>
.auth-form-card {
  padding: 1rem;
}
@media (min-width: 640px) {
  .auth-form-card {
    padding: 1.25rem;
  }
}
</style>
